var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalLayout",
    {
      attrs: {
        navbar: _vm.navbar,
        navbarBottom: _vm.navbarBottom,
        isDark: false,
        isDefaultTheme: true,
      },
    },
    [
      _c("template", { slot: "header" }, [
        _c("h2", { staticClass: "text-secondary mb-0" }, [_vm._v("Supplier")]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }